import React, {Fragment} from "react";

import './FormInputCheckbox.scss' ;
import {Controller} from "react-hook-form";
import {RadioButtonGroup} from "root/ReactHookForm/ui/RadioButtonGroup";

const FormInputRadioButtons = ( { control, onChange, required, sectionName, name, style, className, values, readOnly } ) =>
{
    const classText = className === undefined ? "form-field" : '' ;
    const styleObj = style === undefined ? {} : style ;

    const isHookForm = control !== undefined ;

    const clickHandler = ( event ) =>
    {
        onChange ( event.target.checked ) ;
    }

    const validate = (value) =>
    {
        if ( value === null && required )
        {
            return "Radio is required"
        }
    }

    const controlName = sectionName + '.' + name ;

    return (
        <div className={classText} style={styleObj}>
            { isHookForm === true &&
                <Controller
                    control={control}
                    name={controlName}
                    rules={{ required: required, validate: validate}}
                    render={({ field: { onChange, value, name, ref },
                                 fieldState: { invalid, isTouched, isDirty, error },
                                 formState,
                                 }) => <RadioButtonGroup name={controlName} values={values} initialValue={value} onChange={onChange} readOnly={readOnly}/>}
                />
            }
        </div>
    )
}

export { FormInputRadioButtons };
